import React from 'react';

const AboutPage = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="font-heading font-bold text-3xl text-white mb-6">
        About Us
      </h1>
      <section className="space-y-6 text-slate-300">
        <div>
          <h2 className="font-semibold text-white text-lg">Vision</h2>
          <p>
            To create a safe, real, and verified environment for people to find genuine human
            connection—whether it&apos;s friendship, emotional support, or companionship.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-white text-lg">About</h2>
          <p>
            Stranger69.net is built for those who are tired of fake profiles, bots, and
            time-wasters. We connect verified users and service providers with a premium
            membership. Our vision is simple: help people find real, respectful, and meaningful
            connections—with clear expectations and mutual respect.
          </p>
        </div>
        <div>
          <h2 className="font-semibold text-white text-lg">Why We Charge</h2>
          <p>
            Free platforms attract junk users. By charging a premium, we create a safe, serious,
            and verified environment for everyone.
          </p>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
